// @flow

import { useEffect, useState } from 'react';

import type {
  GetEnrollmentDateParamsType,
  EnrollmentPeriodResType,
} from 'web-core/types/enrollment';

const useEnrollmentPeriods = (
  getPeriods: Function,
  params: GetEnrollmentDateParamsType,
): EnrollmentPeriodResType => {
  const [enrollmentPeriods, setEnrollmentPeriods] = useState({});
  useEffect(() => {
    const getEnrollmentPeriods = async () => {
      const data = await getPeriods(params);
      return setEnrollmentPeriods(data);
    };
    getEnrollmentPeriods();
  }, []);
  return enrollmentPeriods;
};

export default useEnrollmentPeriods;
